import { useState } from "react";

export type ViewMode = "card" | "list";

export function useViewMode(storageKey: string): [ViewMode, (mode: ViewMode) => void] {
  const [mode, setModeState] = useState<ViewMode>(() => {
    try {
      return localStorage.getItem(storageKey) === "list" ? "list" : "card";
    } catch {
      return "card";
    }
  });

  const setMode = (newMode: ViewMode) => {
    try {
      localStorage.setItem(storageKey, newMode);
    } catch {
      // storage unavailable
    }
    setModeState(newMode);
  };

  return [mode, setMode];
}
